import api from './api';
import { nullableUuid } from '@/utils/uuid';

export interface ApontamentoConsumo {
  id: string;
  op_id: string;
  op_numero?: string | null;
  produto_id: string;
  produto_codigo?: string | null;
  produto_descricao?: string | null;
  produto_nome?: string | null;
  lote_id?: string | null;
  lote_numero?: string | null;
  quantidade: number;
  data_consumo: string;
  operacao_id?: string | null;
  responsavel: string;
}

export interface ApontamentoConsumoInput {
  op: string;
  produto: string;
  lote?: string | null;
  quantidade: number;
  data_consumo?: string | null;
  responsavel: string;
  operacao?: string | null;
}

export interface ApontamentoProducao {
  id: string;
  op_id: string;
  op_numero?: string | null;
  operacao_id?: string | null;
  operacao_descricao?: string | null;
  operacao_nome?: string | null;
  lote_producao?: string | null;
  quantidade_produzida: number;
  quantidade_refugo: number;
  data_apontamento: string;
  funcionario: string;
  tempo_real_minutos?: number | null;
  observacoes?: string | null;
}

export interface ApontamentoProducaoInput {
  op: string;
  operacao?: string | null;
  quantidade_produzida: number;
  quantidade_refugo?: number;
  funcionario: string;
  tempo_real_minutos?: number | null;
  data_apontamento?: string | null;
  observacoes?: string;
}

const ENDPOINT_CONSUMO = '/industrializacao/apontamento-consumo';
const ENDPOINT_PRODUCAO = '/industrializacao/apontamento-producao';

/**
 * NOTA: o Laravel real (ApontamentoConsumoController/ApontamentoProducaoController) so'
 * expoe index/store/show/destroy - NAO ha rota de update (confirmado em routes/api.php).
 * O Vue original (ApontamentoService.js) tinha metodos atualizarProducao/atualizarConsumo
 * que NUNCA funcionariam contra o backend real (404). Por isso a porta React NAO oferece
 * edicao de apontamentos, apenas registrar (criar) e estornar (excluir) - condizente com
 * a regra de negocio de um lancamento tipo "ledger" (auditavel, so reversivel via exclusao).
 */
const apontamentoService = {
  consumo: {
    async listar(filters: { op?: string; produto?: string } = {}): Promise<ApontamentoConsumo[]> {
      const response = await api.get<ApontamentoConsumo[]>(ENDPOINT_CONSUMO, { params: filters });
      return response.data;
    },
    async registrar(data: ApontamentoConsumoInput): Promise<ApontamentoConsumo> {
      const response = await api.post<ApontamentoConsumo>(ENDPOINT_CONSUMO, {
        ...data,
        op: nullableUuid(data.op) || '',
        produto: nullableUuid(data.produto) || '',
        lote: nullableUuid(data.lote),
        operacao: nullableUuid(data.operacao),
      });
      return response.data;
    },
    async estornar(id: string): Promise<void> {
      await api.delete(`${ENDPOINT_CONSUMO}/${id}`);
    },
  },
  producao: {
    async listar(filters: { op?: string; funcionario?: string } = {}): Promise<ApontamentoProducao[]> {
      const response = await api.get<ApontamentoProducao[]>(ENDPOINT_PRODUCAO, { params: filters });
      return response.data;
    },
    async registrar(data: ApontamentoProducaoInput): Promise<ApontamentoProducao> {
      const response = await api.post<ApontamentoProducao>(ENDPOINT_PRODUCAO, {
        ...data,
        op: nullableUuid(data.op) || '',
        operacao: nullableUuid(data.operacao),
      });
      return response.data;
    },
    async estornar(id: string): Promise<void> {
      await api.delete(`${ENDPOINT_PRODUCAO}/${id}`);
    },
  },
};

export default apontamentoService;
